import axios from 'axios';
import { API_BASE_URL } from './apiConfig';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Get KPI snapshot data for critical minerals
export const getKpiSnapshotData = async (year = null) => {
  try {
    const url = year ? `/api/kpi-snapshot/minerals?year=${year}` : '/api/kpi-snapshot/minerals';
    console.log('API call to:', url);
    const response = await api.get(url);
    console.log('API response:', response.data);
    
    if (!response.data) {
      throw new Error('Failed to fetch KPI snapshot data');
    }
    
    // Ensure the response has the expected structure
    const responseData = response.data;
    if (responseData.success === undefined) {
      // If the API doesn't return a success field, wrap it
      return {
        success: true,
        data: responseData,
        error: null
      };
    }
    
    return responseData;
    
  } catch (error) {
    console.error('Error fetching KPI snapshot data:', error);
    // Return error response if API fails
    return {
      success: false,
      data: null,
      error: error.message
    };
  }
};

// Get available years for KPI data
export const getAvailableYears = async () => {
  try {
    console.log('API call to: /api/kpi-snapshot/years');
    const response = await api.get('/api/kpi-snapshot/years');
    console.log('Years API response:', response.data);
    
    if (!response.data) {
      throw new Error('Failed to fetch available years');
    }
    
    // Ensure the response has the expected structure
    const responseData = response.data;
    if (responseData.success === undefined) {
      // If the API doesn't return a success field, wrap it
      return {
        success: true,
        data: responseData,
        error: null
      };
    }
    
    return responseData;
    
  } catch (error) {
    console.error('Error fetching available years:', error);
    // Return error response if API fails
    return {
      success: false,
      data: null,
      error: error.message
    };
  }
};

// Get specific mineral KPI data
export const getMineralKpiData = async (mineral) => {
  try {
    const response = await api.get(`/api/kpi-snapshot/mineral/${mineral}`);
    
    if (!response.data) {
      throw new Error(`Failed to fetch KPI data for ${mineral}`);
    }
    
    return response.data;
    
  } catch (error) {
    console.error(`Error fetching KPI data for ${mineral}:`, error);
    return {
      success: false,
      data: null,
      error: error.message
    };
  }
};

// Get risk assessment data for minerals
export const getMineralRiskData = async () => {
  try {
    const response = await api.get('/api/kpi-snapshot/risk-assessment');
    
    if (!response.data) {
      throw new Error('Failed to fetch mineral risk data');
    }
    
    return response.data;
    
  } catch (error) {
    console.error('Error fetching mineral risk data:', error);
    return {
      success: false,
      data: null,
      error: error.message
    };
  }
};

// Get news alerts for a specific mineral
export const getMineralNewsAlerts = async (mineral, limit = 5) => {
  try {
    const response = await api.get(`/api/kpi-snapshot/mineral-alerts/${mineral}`, {
      params: { limit }
    });
    
    if (!response.data) {
      throw new Error(`Failed to fetch news alerts for ${mineral}`);
    }
    
    return response.data;
    
  } catch (error) {
    console.error(`Error fetching news alerts for ${mineral}:`, error);
    return {
      success: false,
      data: {
        mineral: mineral,
        alerts: [],
        alert_count: 0,
        error: error.message
      }
    };
  }
};